import React, { useState, useEffect } from "react";
import { Table, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
import { fetchPendingClasses } from "../../ApiServices/classAdminApi";
import { getClassesTableColumns } from "../../Config/classesTableColumns";
import "./Classes.css";

function Classes() {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const navigate = useNavigate();

  const fetchClasses = async (page = 1) => {
    setLoading(true);
    try {
      const response = await fetchPendingClasses(page);
      console.log("Response data:", response);
      
      if (response.code === 200 && Array.isArray(response.data.classes)) {
        setClasses(response.data.classes);
        setPagination(prev => ({
          ...prev,
          total: response.data.pages || 0,
          current: page,
        }));
      } 
    } catch (error) {
      message.error("Error fetching classes: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClasses(pagination.current);
  }, [pagination.current]);

  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  const handleRowClick = (record) => {
    navigate(`/preview-class/${record.id}`);
  };

  const columns = getClassesTableColumns(navigate, fetchClasses, pagination.current);

  return (
    <div className="admin-classes">
      <span>Pending Submitted Classes</span>
      <Table
        columns={columns}
        dataSource={classes}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: false,
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        style={{ width: '100%' }}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}

export default Classes;